import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config.service';
import { environment as env } from 'src/environments/environment';
import { AddExistingMemberPayload, DeleteMemberApi, EditMemberApi, EditMemberPayload, EditRoleApi, ExistingMemberApi, InviteNewMemberApi, MemberListApi,StudyBaseMemberListApi, type InviteNewMemberPayload } from '../models/study';
import {
  BucketDetailsResponse,
  haloDetailsResponse,
  InfraDetailsResponse,
  OldOrNewStudy,
  PositDetailsResponse,
  VSCodeExtensionResponse
} from '../models/analytics';
import { 
  cloud9Response, 
  DataIngressResponse, 
  DataSet, 
  DatasetID, 
  DataSetPayload, 
  EC2InstanceSize, 
  GenerateKey, 
  GetJupyterInstance, 
  HTCFileSize, 
  SchemaListResponse,
  HTCFNodeInstance, 
  IngressFiles, 
  IngressFilesResponse, 
  IngressResponse, 
  JupyterInstancePayload, 
  MetaDataPayLoad, 
  MetaDataResponse, 
  NftPayLoad, 
  SageMakerProfile, 
  SageMakerResponse, 
  Schema, 
  SchemaResponse, 
  sFTPURL,
  DataInstanceResponse,
  CustomHPCPayload,
  QCDetailsResponse,
  CopyDatasetPayload} from '../models/ingress';
import { ControlBase } from '../models/control-base';
import { MetadataDropdown } from '../models/metadata-dropdown';
import { Metadata } from '../models/metadata';
import { MetadataDateTime } from '../models/metadata-datetime';
import { MetadataTextbox } from '../models/metadata-textbox';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MetadataNumberbox } from '../models/metadata-numberbox';
import { AccessService } from 'src/app/shared/services/access.service';


@Injectable({
  providedIn: 'root'
})
export class EnclaveStudyDetailsService {
  masterSchema!: Schema;
  metaDataValidality = new BehaviorSubject(true);
  saveExitOrNextBtnClickInMetadata = new BehaviorSubject(false);
  modifiedStatusChange = new BehaviorSubject("");
  isLoading: boolean = false;
  dataIngressFileUploadData = {};
  selectedCatalogue!: any;
  controls!: ControlBase<string>[];
  typeDetails:{"key":string,"type":string}[]=[];
  validators:any[] = [];
  ingressFileList = new BehaviorSubject<IngressFiles[]>([]);
  data$:Observable<IngressFiles[]> = this.ingressFileList.asObservable();
  datasetcreatedByFullName=new BehaviorSubject<string>('')
  isShowCSI = env.PERMISSIONS.APP_HOSTING_SHOW;
  readonly isQCRunEnabled = new BehaviorSubject<boolean>(false);
  readonly isQCReturnToEnabled = new BehaviorSubject<boolean>(false);
  selectedDatasetInfo = new BehaviorSubject<any>({});
  readonly setQCStatus = new BehaviorSubject<string|null>('');
  readonly openQCDrawerSubject = new BehaviorSubject<string | null>(null);
  generatedDatasetName:string = '';
  selectedSourceTab:string='';
  saveInitiatedStatus:boolean=false;
  selectedQCmodel!:any;
  selectedQCAvailableApp:any=[];
  constructor(
    private readonly configService: ConfigService,
    private http: HttpClient,
    private readonly accessService:AccessService
  ) { }

  filterIngressByStatus(payload: DataSetPayload,nextToken:string) {
    const url = this.configService.config['domain'] + env.ingressApi;
    const params = {
      status: payload.status,
      studyKey: payload.studyKey,
      substudyKey:(payload.substudyKey)?payload.substudyKey:'',
      size: 25,
      nextToken: nextToken
    }
    return this.http.get<DataIngressResponse>(url,{ params: params });
  }

  getSharedDatasetList(payload: any,nextToken:string) {
    const url =  this.configService.config['domain'] + env.shareDatasetsApi;
    const params = new HttpParams()
    .set('size', '100')
    .set('nextToken', nextToken)
    .set('parentStudyKey', payload.parentStudyKey)
    .set('subStudyKey',payload.subStudyKey)
    return this.http.get<DataIngressResponse>(url , { params: params });
  }





  filterInboxByStatus(status: string | number, nextToken: string) {
    const category = 'DATASET-SUBMIT';
    const url = this.configService.config['domain'] + env.inbox +'/'+category;
    const params = new HttpParams()
      .set('size', '100')
      .set('nextToken', nextToken)
      .set('status', status)
    return this.http.get<IngressResponse>(url, { params: params });
  }

  saveInboxByStatus(requestPayLoad: any) {   
    const url = this.configService.config['domain'] + env.inbox ;
    return this.http.put<any>(url, requestPayLoad);
  }

  createDataSet(payload: DataSet) {
    const url = this.configService.config['domain'] + env.dataset;
    return this.http.post<DatasetID>(url, payload);
  }

  editDataSet(payload: DataSet,datasetId:string) {
    const url = this.configService.config['domain'] + env.dataset+"/"+datasetId;
    return this.http.put<DatasetID>(url, payload);
  }

  datasetQCReason(studyKey:string,datasetId:string,payload:any) {
    const url = this.configService.config['domain'] + env.provideReason+"/"+studyKey+"/"+datasetId;
    return this.http.post<DatasetID>(url, payload);
  }

  getDataset(id: string,subStudyKey:string) {
    // Guard against undefined, null, or invalid dataset ID
    if (!id || id === 'undefined' || id === 'null') {
      return throwError(() => new Error(`Invalid dataset ID: ${id}`));
    }
    
    const url = this.configService.config['domain'] + env.dataset + '/' + id;
    const params = {
      subStudyKey
    }
    return this.http.get<DatasetID>(url,{ params: params });
  }
  getImageResult(datasetId: string) {
    const url = this.configService.config['domain'] + env.imageQCResult + '/' + datasetId;
    return this.http.get<DatasetID>(url);
  }
  addFilesDataSet(payload: Partial<IngressFiles>[]) {
    const url = this.configService.config['domain'] + env.addFiles;
    return this.http.post<Partial<IngressFiles>[]>(url, payload);
  }

  datasetSubmit(payload:any) {
    const url = this.configService.config['domain'] + env.datasetSubmit;
    return this.http.post(url, payload);
  }

  copyDatasetFiles(payload: CopyDatasetPayload) {
    const url = this.configService.config['domain'] + env.copyDataset;
    return this.http.post(url, payload);
  }

  removeFilesDataSet(payload: IngressFiles[]) {
    const url = this.configService.config['domain'] + env.addFiles;
    return this.http.delete(url, { body: payload});
  }

  getFilesDataSet(id: string,key:string='',limit:number=1000,token:string='') {
    // Guard against undefined, null, or invalid dataset ID
    if (!id || id === 'undefined' || id === 'null') {
      return throwError(() => new Error(`Invalid dataset ID: ${id}`));
    }
    
    const url = this.configService.config['domain'] + env.dataset + '/' + id + '/file?size='+limit+'&nextToken='+token;
   
    const params:any = {};
   
    if (key) {
      params.subStudyKey = key;
    }

    return this.http.get<IngressFilesResponse>(url, { params: params });
  }

  getIngressSchema(enclaveKey: string) {
    
    const url = this.configService.config['domain'] + env.ingressSchemaApi + '/' + enclaveKey;    
    return this.http.get<SchemaResponse>(url);
  }

  getsFTPDetails(email: string) {
    const url = this.configService.config['domain'] + env.sfTPDetails;
    const params = {
      "userEmail": email
    }
    return this.http.get<any>(url, { params: params });
  }

  getsFTPURL(studyKey: string, resourceKey: string) {
    const url = this.configService.config['domain'] + env.sFTPURL
    const params = {
      "studyKey": studyKey,
      'resourceKey': resourceKey
    }
    return this.http.get<sFTPURL>(url, { params: params });
  }


  getMetaDataDetail(datasetId : string | null) {
    const url = this.configService.config['domain'] + env.dataIngressGetMetadata + '/' + datasetId + '/metadata';
    return this.http.get<MetaDataResponse>(url);
  }

  createMetaData(payload:MetaDataPayLoad) {
    const url = this.configService.config['domain'] +env.saveIngress;
    return this.http.post<MetaDataResponse>(url, payload);
  }
  updateMetaData(payload:MetaDataPayLoad,schemaId:string) {
    const url = this.configService.config['domain'] +env.updateMetaSchemas+"/"+schemaId;
    return this.http.put<MetaDataResponse>(url, payload);
  }
  
  anaylyticsInstances(id: string,nextToken:any) {
    const params = new HttpParams()
      .set('size', '100')
      .set('nextToken', nextToken);
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + id + "/analytics/ondemand/instance";
    return this.http.get<DataInstanceResponse>(url,{ params: params });
  }

  inviteNewMember(payload:InviteNewMemberPayload){
    const url = this.configService.config['domain'] + env.inviteNewMemberApi;
    return this.http.post<InviteNewMemberApi>(url, payload);
  }

  addExistingMember(payload:AddExistingMemberPayload[]){
    const url = this.configService.config['domain'] + env.inviteExistingMemberApi;
    return this.http.post<ExistingMemberApi>(url, payload);
    
  }
  getMemberDetailsByEmail(email:string){
    const url = this.configService.config['domain'] + env.memberDetailsByEmailApi;
    const params = {
      "userEmail":email
    }
    return this.http.get<IngressResponse>(url , { params: params });
  }

  viewMemberList(studyKey:string,size:number,nextToken:string){
    const url = this.configService.config['domain'] + env.viewMemberApi;
    const params = {
      "studyKey":studyKey,
      "size":size,
      "nextToken":nextToken
    }
    return this.http.get<MemberListApi>(url,{ params: params });
  }

  editMember(payload:EditMemberPayload){
    const url = this.configService.config['domain'] + env.editMemberApi;
    return this.http.put<EditMemberApi>(url, payload);
    
  }

  getMembersDetailList(studyKey:string){
    const url = this.configService.config['domain']  + env.membersListApi + "/" + studyKey;
    return this.http.get<StudyBaseMemberListApi>(url);
  }

  removeMember(id:{id:string,studyKey:string}){
    const url = this.configService.config['domain'] + env.editMemberApi;
    return this.http.delete<DeleteMemberApi>(url, { body: id});
    
  }
  getexcludedCurrentRoleList(roleName:string){
    const url = this.configService.config['domain'] + env.excludeCurrentroleApi;
    const params = {
      "roleName":roleName
    }
    return this.http.get<EditRoleApi>(url,{ params: params });
  }

  getRoleListByRoleType(roleType:string){
    const url = this.configService.config['domain'] + env.getRoleByType +'/'+roleType;
    return this.http.get<EditRoleApi>(url);
  }



  getSagmakerUserProfile(id:string) {
    const url = this.configService.config['domain'] + env.analyticsInstance+"/"+id+"/analytics/sagemakeruserprofile"; 
    return this.http.get<SageMakerResponse>(url);
  }

  getCloud9(id:string) {
    const url = this.configService.config['domain'] + env.analyticsInstance+"/"+id+"/analytics/cloud9"; 
    return this.http.get<SageMakerResponse>(url);
  }

  getInfraDetail(id: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance+"/"+id+"/analytics/infradetail"; 
    return this.http.get<InfraDetailsResponse>(url);
    
  }

  gethpcInstanceSize() {
    const url = this.configService.config['domain'] + env.instarnceSize+"/hpcInstanceSize/contents"; 
    return this.http.get<HTCFileSize>(url);
  }

  getec2InstanceSize() {
    const url = this.configService.config['domain'] + env.instarnceSize+"/ec2InstanceSize/contents"; 
    return this.http.get<EC2InstanceSize>(url);
  }

  
  gethjupyterInstanceSize() {
    const url = this.configService.config['domain'] + env.instarnceSize+"/jupyterInstanceSize/contents"; 
    return this.http.get<GetJupyterInstance>(url);
  }

  getCustomHPCDetails(studyKey:string,availabilityZone:string,scheduler:string) {
     const params = {
     studyKey,
     availabilityZone,
     scheduler
    }
      const url = this.configService.config['domain'] + env.analyticsInstance+"/customhpc/config"; 
    return this.http.get<GetJupyterInstance>(url,{params:params});
  }
 
  getPosit(id: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + id + "/analytics/positurl";
    return this.http.get<PositDetailsResponse>(url);
  }

  getHalo(id: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + id + "/analytics/halourl";
    return this.http.get<haloDetailsResponse>(url);
  }

  getVSCodeExtensionDetails(id: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/vscodeextension/" + id;
    return this.http.get<VSCodeExtensionResponse>(url);
  }

  getStudyBucket(id: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance+"/"+id+"/analytics/studybucketdetails"; 
    return this.http.get<BucketDetailsResponse>(url);
  }

  saveJupyterInstance(payload: JupyterInstancePayload) {
    const url = this.configService.config['domain'] +env.analyticsInstance + "/analytics/jupyternotebook";
    return this.http.post<MetaDataResponse>(url, payload);
  }

  saveEc2Instance(payload: JupyterInstancePayload) {
    const url = this.configService.config['domain'] +env.analyticsInstance + "/analytics/ec2instance";
    return this.http.post<MetaDataResponse>(url, payload);
  }

   saveCustomHPC(payload:CustomHPCPayload ) {
    const url = this.configService.config['domain'] +env.analyticsInstance + "/customhpc";
    return this.http.post<MetaDataResponse>(url, payload);
  }

  getJupterInstance(instanceId: string, studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch + "/" + studyKey + "/analytics/launch/jupyternotebook/" + instanceId; 
    window.open(url, '_blank');
  }

  getEc2Instance(instanceId: string, studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch + "/" + studyKey + "/analytics/launch/ec2instance/" + instanceId; 
    window.open(url, '_blank');
  }

  getGenerateKey(studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + studyKey + "/analytics/cloud9/credentials";
    return this.http.get<GenerateKey>(url);
  }

  postNftLogin(email: NftPayLoad) {
    const url = this.configService.config['domain'] + env.nftLogin;
    return this.http.post<cloud9Response>(url, email);
  }
  
  getLaunchSageMaker(studyKey: string, appName: string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch  + "/" + studyKey + "/analytics/launch/"+appName+"/sagemakeruserprofile";
    window.open(url, '_blank');
  }

  saveSageMakerProfile(payload: SageMakerProfile) {
    const url = this.configService.config['domain'] + env.analyticsInstance +"/analytics/sagemakeruserprofile";
    return this.http.post<SageMakerResponse>(url, payload);
  }

  terminateInstance(studyKey: string, instanceId : string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + studyKey + "/analytics/instance/" + instanceId;
    return this.http.delete<SageMakerResponse>(url);
  }

  startOrStopEC2Instance(studyKey: string, instanceId: string, action: string ) {
    let payload = {};
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + studyKey + "/manageInstance/" + action + "/" + instanceId;
    return this.http.post<any>(url,payload)
  }

  saveCloud9(payload: SageMakerProfile){
    const url = this.configService.config['domain'] + env.analyticsInstance +"/analytics/cloud9";
    return this.http.post<SageMakerResponse>(url, payload);
  }

  getCloud9Launch(studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch  + "/" + studyKey + "/analytics/launch/cloud9";
    window.open(url, '_blank');
  }

  getHpcInstanceDetails(studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/analytics/hpcinstancedetails/" + studyKey;
    return this.http.get<HTCFNodeInstance>(url);
  }

  getHpcLaunch(studyKey: string, instanceId:string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch  + "/" + studyKey + "/analytics/launch/hpc/"+instanceId;
    window.open(url, '_blank');
  }

  submitMetadata(payload:any){
    const url = this.configService.config['domain'] + env.dataIngressSubmit;
    return this.http.post<any>(url, payload);

  }

  saveHPCData(studyKey: string, instanceId: string, action:string) {
    let payload = {};
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + studyKey + "/manageInstance/"+action+"/"+ instanceId ;
    return this.http.post<any>(url, payload);
  }

  getAllInstanceSizeList(instanceType: string, availabilityZone: string = '') {
    let url = this.configService.config['domain'] + env.analyticsInstance+"/instancetypes/"+instanceType;
    if (availabilityZone) {
      url += `?availabilityZone=${encodeURIComponent(availabilityZone)}`;
    }
    return this.http.get<HTCFileSize>(url);
  }

  getHpcInformation(studyKey: string, instanceId: string) {
    const url = this.configService.config['domain'] + env.analyticsInstance+"/"+studyKey+"/hpc/info/"+instanceId; 
    return this.http.get<any>(url);
  }
  
  terminateHPC(studyKey: string, instanceId : string) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/customhpc/" + instanceId + "/" + studyKey;
    return this.http.delete<any>(url);
  }

  getPermissionForAnalytics(studyKey:string){
    const url = this.configService.config['domain']  + env.analyticsPagePermission + "/" + studyKey;
    return this.http.get<OldOrNewStudy>(url);
  }

  getSchemaList(studyKey: string=''){
    const key = (studyKey?`/${studyKey}`:'');
    const url = this.configService.config['domain'] + env.getSchemaList+key;
    return this.http.get<SchemaListResponse>(url);
  }

  getRedCapSchemaList(studyKey: string=''){
    const key = (studyKey?`/${studyKey}`:'');
    const url = this.configService.config['domain'] + env.getRedCapSchemaList+key;
    return this.http.get<SchemaListResponse>(url);
  }
  
  getMetadataSchemaByGroup(schemaIdentifier:string,schemaType:string){
  const url = this.configService.config['domain'] + env.getSchemaData+"/"+schemaIdentifier+"/"+schemaType; 
   return this.http.get<any>(url);
  }

  typeBasedObject(controlNameKey:string,listEnum: { data_type?:any; enum: any; label?: any; value: any; hidden: any; readonly: any; displayOrder: any; },jsonValue: { required: string | string[]; },listoreder: number){
    return {
      formControlName: controlNameKey,
      label: listEnum.label?listEnum.label:controlNameKey,
      placeholder: listEnum.label?listEnum.label:controlNameKey,
      options: listEnum.enum,
      value: listEnum.value?listEnum.value:'',
      required: jsonValue.required.includes(controlNameKey),
      order: 1,
      data_type:listEnum.data_type?listEnum.data_type:'',
      hidden: listEnum.hidden ? listEnum.hidden : false,
      readonly: listEnum.readonly ? listEnum.readonly : false,
      displayOrder: listEnum.displayOrder ? listEnum.displayOrder : listoreder
    }
  }

  createFieldByType(controlNameKey: string, controlType: { type: any; }, listoreder: number, jsonValue: any) {
    switch (controlType.type) {
      case 'string':
        {
          this.controls.push(new MetadataTextbox(this.jsoncontrolTypeObject(controlNameKey, controlType, listoreder, jsonValue, 'text')));
          break;
        }
        case 'number':
        {
          this.controls.push(new MetadataNumberbox(this.jsoncontrolTypeObject(controlNameKey, controlType, listoreder, jsonValue, 'number')));
          break;
        }
      case 'elnLookup':
        {
          this.controls.push(new MetadataTextbox(this.jsoncontrolTypeObject(controlNameKey, controlType, listoreder, jsonValue, 'elnLookup')));
          break;
        }
      case 'date':
        {
          this.controls.push(new MetadataDateTime(this.jsoncontrolTypeObject(controlNameKey, controlType, listoreder, jsonValue, 'dateTime')));
          break
        }
    }
  }
  
  jsoncontrolTypeObject(controlNameKey: string,controlType: { type?: any; label?: any; value?: any; pattern?: any; data_type?:any; hidden?: any; readonly?: any; displayOrder?: any; minLength?:number,maxLength?:number,minimum?:number,maximum?:number,maxNumberLength?:number},listoreder: number,jsonValue: { required: string | any[]; },type: string){
    return {
     formControlName: controlNameKey,
     label: controlType.label ? controlType.label :controlNameKey,
     placeholder: controlType.label ? controlType.label :controlNameKey,
     value: controlType.value ? controlType.value :'',
     required: (jsonValue.required)?jsonValue.required.includes(controlNameKey):false,
     type,
     order: 1,
     pattern: controlType.pattern ? controlType.pattern : null,
     hidden: controlType.hidden ? controlType.hidden : false,
     readonly: controlType.readonly ? controlType.readonly : false,
     data_type: controlType.data_type ? controlType.data_type:'',
     displayOrder: controlType.displayOrder ? controlType.displayOrder : listoreder,
     minLength: controlType.minLength,
     maxLength: controlType.maxLength,
     maximum:controlType.maximum,
     minimum:controlType.minimum,
     maxNumberLength:controlType.maximum?.toString().length
   }
   }
  readJSON(jsonValue:any): Metadata {
    const listoreder = 9999;  
    this.controls = [];
    for(const controlNameKey in jsonValue.properties) {
      for (const typeKey in jsonValue.properties[controlNameKey]) {
        switch (typeKey) {
          case 'enum': {
            const listEnum = jsonValue.properties[controlNameKey];
            this.controls.push(new MetadataDropdown(this.typeBasedObject(controlNameKey,listEnum,jsonValue,listoreder)));
            break;
          }

          case 'type': {
            const controlType = jsonValue.properties[controlNameKey];
            this.createFieldByType(controlNameKey, controlType, listoreder, jsonValue)
            break;
          }
        }
      }
    }
    
     return new Metadata('', this.controls);
  }

  toFormGroup(controls: ControlBase<string>[]) {
    const group: any = {};
    this.typeDetails = [];
    controls.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });
  controls.forEach(control => {
       const dynamicallyAddedValidators = this.getValidators(control);

       const valueObject={"key":control.formControlName,"type":control.type};
       this.typeDetails.push(valueObject);

       if (dynamicallyAddedValidators.length >= 1) {
        group[control.formControlName] = new FormControl({ value: control.value || '', disabled: control.readonly ? true : false }, dynamicallyAddedValidators);
      
        
       }
       else {
        group[control.formControlName] = new FormControl({ value: control.value || '', disabled: control.readonly ? true : false });
     
       }
    });
    return new FormGroup(group);
  }
 

  getValidators(control: ControlBase<string>){

    this.validators= [];
          if (control.pattern) {
          this.validators.push(Validators.pattern(control.pattern));
          }
          if (control.minimum) {
            this.validators.push(Validators.min(control.minimum));
          }
          if (control.maximum) {
            this.validators.push(Validators.max(control.maximum));
          }
          if (control.required) {
            this.validators.push(Validators.required);
          }
          if (control.minLength) {
            this.validators.push(Validators.minLength(control.minLength));
          }
          if (control.maxLength) {
            this.validators.push(Validators.maxLength(control.maxLength));
          }
          
    return this.validators;
  }

  getUserInfo():string{
    const userEmail = this.accessService.permissionDetails?.userEmail;
    if(userEmail?.endsWith('roche.com') || userEmail.endsWith('gene.com')){
        return 'internal';
    }else{
        return 'external';
    }
  }
  
  getSupportAppsInfo(studyId: string) {    
    const url = this.configService.config['domain'] + env.analyticsInstance + "/supportedapp/" + studyId;
    return this.http.get<any>(url);
  }

  getInstallApps(studyKey:string) {    
    const url = this.configService.config['domain'] + env.analyticsInstance + "/installedapp/" + studyKey;
    return this.http.get<any>(url);
  }

  getInstallAppsInfo(appId: string) {    
    const url = this.configService.config['domain'] + env.analyticsInstance + "/installedappstatus/"+ appId;
    return this.http.get<any>(url);
  }

  SaveSupportApp(payload: any) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/supportedapp/install";
    return this.http.post<any>(url, payload);
  }

   SaveMangeApp(payload: any) {
    const url = this.configService.config['domain'] + env.analyticsInstance + "/dp/supportedapp/install";
    return this.http.post<any>(url, payload);
  }
 getAppAdditionalInfo(appId: any, studyKey: string) {
     const url = this.configService.config['domain']  + env.analyticsInstance + "/appinfradetail/"+ appId + "/" + studyKey;
    return this.http.get<any>(url);
  }

  qcSumbit(payload: any) {
    const url = this.configService.config['domain'] + env.qckitingestion;
    return this.http.post<any>(url, payload);
  }

  getAppAdditional(studyKey: string) {
     const url = this.configService.config['domain']  + env.analyticsInstance + "/additionalappdetails/"+ studyKey;
    return this.http.get<any>(url);
  }

  getCsiDetail(studyKey:any) {
    const url = this.configService.config['domain'] + env.csiDetails + "/" + studyKey;
    return this.http.get<any>(url);
  }

  saveCsiDetail(payload:any) {
    const url = this.configService.config['domain'] + env.csiDetails;
    return this.http.post<DatasetID>(url, payload);
  }

  getCsi() {
    const url = this.configService.config['domain'] + env.csiDetails;
    return this.http.get<any>(url);
  }

   saveSecondaryRole(studyKey:string) {
    let payload = {
      "studyKey": studyKey
    }
    const url = this.configService.config['domain'] + env.csiDetails + "/role";
    return this.http.post<DatasetID>(url, payload);
  }

  deleteSecondaryRole(studyKey:string) {
    const url = this.configService.config['domain'] + env.csiDetails + "/role/" + studyKey;
    return this.http.delete<any>(url);
  }

  saveSecondaryRoleMember(payload:any) {
    const url = this.configService.config['domain'] + env.csiDetails + "/user";
    return this.http.post<DatasetID>(url, payload);
  }

  getITAdmin(id:string) {
    const url = this.configService.config['domain'] + env.analyticsInstance+"/"+id+"/analytics/aws/launchvisible";
    return this.http.get<any>(url);
  }
  

  getAWSUrl(studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch + "/" + studyKey + "/analytics/launch/awsconsole";
    window.open(url, '_blank');
  }

   getSecondaryRoleMember(userId: string, studyKey: string) {
    const url = this.configService.config['domain'] + env.csiDetails + "/user/" + studyKey + "/" + userId;
    return this.http.get<any>(url);
  }

   DeleteSecondaryRoleMember(userId: string, studyKey: string) {
    const url = this.configService.config['domain'] + env.csiDetails + "/user/" + studyKey + "/" + userId;
    return this.http.delete<any>(url);
  }

   getS3DataLaunch(studyKey: string) {
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch + "/" + studyKey + "/analytics/launch/s3console?type=data";
    window.open(url, '_blank');
  }

  getOutputDataLanuch(studyKey: string){
    const url = this.configService.config['domain'] + env.analyticsInstanceLaunch + "/" + studyKey + "/analytics/launch/s3console?type=output";
    window.open(url, '_blank');
  }

  getQCStatusForSelectedFiles(datasetId:string){
    const url = this.configService.config['domain'] + env.getQCResult + '/' + datasetId;
    return this.http.get<any>(url)
  }
  
  savePositConnect(studyKey:string){   
    let payload = {
      "studyKey":studyKey
    } 
    const url = this.configService.config['domain']  + env.positConnect + "/role";
    return this.http.post<any>(url,payload);
  }

  getPositConnect(studyKey:string){   
    const url = this.configService.config['domain']  + env.positConnect + "/" + studyKey;
    return this.http.get<any>(url);
  }
  
  getQCModelData(studyKey:string,appType:string){
    const url = this.configService.config['domain'] + env.analyticsInstance + '/installedapp/config/' + studyKey + '/'+ appType;
    return this.http.get<QCDetailsResponse>(url);
  }

 sendFilesForQCCheck(payload:any){
    const url = this.configService.config['domain'] + env.sendFilesForQCCheck;
    return this.http.post<any>(url, payload);
}

sendFilesForQCOverridepass(payload:any){
   const url = this.configService.config['domain'] + env.sendFilesForQCOverridepass;
    return this.http.post<any>(url, payload);
}

toDiscardQCstatus(datasetId:string,studyKey:string,appId:string){
   const params = {
     datasetId,
     studyKey,
     appId
    }

   const url = this.configService.config['domain'] + env.discardQC
    return this.http.delete<GetJupyterInstance>(url,{params:params});
}

 downloadCSV(name: string):Observable<Blob> {
    const url =  this.configService.config['domain'] +  env.downloadQCCSV + '/' + name;
    return this.http.get<any>(url,{responseType:'blob' as 'json'})
  }

  getFileIngressCheck(datasetId:string,studyKey:string){
  const url = this.configService.config['domain']  + env.getdraftFileStatus + "?datasetId="+datasetId+"&studyKey="+studyKey;
    return this.http.get<any>(url);
 }

  getFeatures(version: string) {
    const url =  this.configService.config['domain'] +  env.featureApi + '/' + version
    return this.http.get<any>(url)
  }

  getAvilabilityZone() {
    const url = this.configService.config['domain']  + env.analyticsInstance + "/analytics/availabilityZones";
    return this.http.get<any>(url);
  }

  addHpcUser(studyKey:string,instanceId:string){
    let payload = {};
    const url = this.configService.config['domain'] + env.analyticsInstance + "/" + studyKey + "/analytics/instance/"+ instanceId +"/adduser";
    return this.http.post<any>(url, payload);
  }

  startOrStopJupyterInstance(instanceId: string, action:string) {
    let payload = {};
    const url = this.configService.config['domain'] + env.jupyterInstance + "/" + action + '/' + instanceId;
    return this.http.post<any>(url,payload)
  }
}